import { type ReferralInput, type ReferralService } from './ReferralService'
import { type ReferralType } from '../../model/referral'
import { httpsCallable } from 'firebase/functions'
import { functions } from '../../db'

export class ReferralServiceImpl implements ReferralService {
  async createReferral(input: ReferralInput): Promise<ReferralType> {
    const create = httpsCallable<ReferralInput, ReferralType>(
      functions,
      'createReferral'
    )
    const result = await create(input)
    return result.data
  }

  async getReferrals(): Promise<ReferralType[]> {
    const getAll = httpsCallable<Record<string, never>, ReferralType[]>(
      functions,
      'getReferrals'
    )
    const result = await getAll({})
    return result.data
  }
}
